import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFullScreenModeExpand = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.5 3.5625C3.98223 3.5625 3.5625 3.98223 3.5625 4.5V6C3.5625 6.31066 3.31066 6.5625 3 6.5625C2.68934 6.5625 2.4375 6.31066 2.4375 6V4.5C2.4375 3.36091 3.36091 2.4375 4.5 2.4375H6C6.31066 2.4375 6.5625 2.68934 6.5625 3C6.5625 3.31066 6.31066 3.5625 6 3.5625H4.5Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.5 3.5625C14.0178 3.5625 14.4375 3.98223 14.4375 4.5V6C14.4375 6.31066 14.6893 6.5625 15 6.5625C15.3107 6.5625 15.5625 6.31066 15.5625 6V4.5C15.5625 3.36091 14.6391 2.4375 13.5 2.4375H12C11.6893 2.4375 11.4375 2.68934 11.4375 3C11.4375 3.31066 11.6893 3.5625 12 3.5625H13.5Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.5 14.4375C3.98223 14.4375 3.5625 14.0178 3.5625 13.5V12C3.5625 11.6893 3.31066 11.4375 3 11.4375C2.68934 11.4375 2.4375 11.6893 2.4375 12V13.5C2.4375 14.6391 3.36091 15.5625 4.5 15.5625H6C6.31066 15.5625 6.5625 15.3107 6.5625 15C6.5625 14.6893 6.31066 14.4375 6 14.4375H4.5Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.5 14.4375C14.0178 14.4375 14.4375 14.0178 14.4375 13.5V12C14.4375 11.6893 14.6893 11.4375 15 11.4375C15.3107 11.4375 15.5625 11.6893 15.5625 12V13.5C15.5625 14.6391 14.6391 15.5625 13.5 15.5625H12C11.6893 15.5625 11.4375 15.3107 11.4375 15C11.4375 14.6893 11.6893 14.4375 12 14.4375H13.5Z",
			fill: "#33373D"
		})
	]
});
export { SvgIconFullScreenModeExpand as ReactComponent };
